import { SchoolDetailBlogInputType } from '../../type/Blog/SchoolDetailBlogInput.type';

export const schoolDetailBlogInputInitial: SchoolDetailBlogInputType = {
    title: "",
    text: "",
    image: null,
    deletingImage: false,
}
